import { DatePicker as MuiDatePicker } from '@material-ui/pickers';
import { formatISO9075 } from 'date-fns';
import PropTypes from 'prop-types';
import { useRef } from 'react';

import TextField from './TextField';

const DatePicker = ({
  fullWidth,
  variant = 'inline',
  onChange = () => {},
  classes,
  label,
  inputProps,
  ...props
}) => {
  const ref = useRef();

  const handleChange = (value) => {
    onChange(new Date(formatISO9075(value).replace(/-/g, '/')));
  };

  return (
    <MuiDatePicker
      format="EEEE d LLLL yyyy"
      onChange={handleChange}
      PopoverProps={{
        anchorEl: () => ref.current,
      }}
      TextFieldComponent={({ onClick, value }) => (
        <TextField
          classes={classes}
          fullWidth={fullWidth}
          inputRef={ref}
          label={label}
          onClick={onClick}
          value={value}
          {...inputProps}
        />
      )}
      variant={variant}
      // views={['year', 'month']
      {...props}
    />
  );
};

DatePicker.propTypes = {
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  label: PropTypes.string,
  inputProps: PropTypes.object,
};

export default DatePicker;
